/* The storefront height comes from CSS; only the theme editor needs a readout. */
(function () {
  if (window.__homeCampaignGuides || !window.Shopify || !window.Shopify.designMode) return;
  window.__homeCampaignGuides = true;
  var observers = new Map();
  function attach(root) {
    root.querySelectorAll('.HomeSlideshow').forEach(function (section) {
      var guide = section.querySelector('[data-home-image-guide]');
      var media = section.querySelector('.HomeSlideshow__Media');
      if (!guide || !media || observers.has(section)) return;
      function describe() {
        var bounds = media.getBoundingClientRect();
        var device = window.innerWidth <= 640 ? 'Mobile' : window.innerWidth <= 1180 ? 'Tablet' : 'Desktop';
        guide.textContent = device + ' image area: ' + Math.round(bounds.width) + ' × ' + Math.round(bounds.height) + 'px · ratio ' + (bounds.width / Math.max(bounds.height, 1)).toFixed(2) + ':1. Images crop to fill; check the focal point and space behind the text.';
      }
      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(describe);
        observer.observe(media);
        observers.set(section, observer);
      }
      describe();
    });
  }
  attach(document);
  document.addEventListener('shopify:section:load', function () { attach(document); });
  document.addEventListener('shopify:section:unload', function (event) {
    observers.forEach(function (observer, section) {
      if (event.target.contains(section)) { observer.disconnect(); observers.delete(section); }
    });
  });
})();
